import { useState } from "react";
import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "../ui/sheet";
import { NAV, CONTACT } from "../../lib/catalog";

export const MobileMenu = ({ trigger }) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>{trigger}</SheetTrigger>
      <SheetContent side="right" data-lenis-prevent className="w-[88vw] max-w-sm overflow-y-auto border-[#D4AF37]/30 bg-[#1d051a] text-[#FFF8EF]" data-testid="mobile-menu">
        <SheetHeader>
          <SheetTitle className="font-display text-3xl italic text-[#F3E5AB]">Our Collection</SheetTitle>
        </SheetHeader>
        <div className="mt-6 space-y-1">
          {NAV.map((c) => (
            <Link key={c.slug} to={`/c/${c.slug}`} onClick={close} className={`block rounded-xl px-4 py-3 font-medium hover:bg-[#330B2E] ${c.festive ? "text-[#F3E5AB]" : ""}`} data-testid={`mobile-tab-${c.slug}`}>{c.name}</Link>
          ))}
        </div>
        <div className="mt-8 border-t border-[#D4AF37]/20 pt-6 text-sm text-[#E8D8C8]">
          <div className="mb-6 flex flex-wrap gap-x-5 gap-y-2 text-[#FFF8EF]">
            <Link to="/booking-list" onClick={close} data-testid="mobile-booking-link">Booking list</Link>
            <Link to={{ pathname: "/", hash: "faqs" }} onClick={close}>FAQs</Link>
            <Link to={{ pathname: "/", hash: "about" }} onClick={close}>About us</Link>
          </div>
          <a href={`tel:${CONTACT.tel}`} className="block font-display text-2xl text-[#F3E5AB]">{CONTACT.phone}</a>
          <p className="mt-2">Three days prior booking required for home delivery.</p>
        </div>
      </SheetContent>
    </Sheet>
  );
};
